import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AiBadge from '@/components/common/AiBadge.vue'
import SpeechMicButton from '@/components/speech/SpeechMicButton.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('v-select', vSelect)
Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
Vue.component('AiBadge', AiBadge)
Vue.component('SpeechMicButton', SpeechMicButton)
